module.exports = __webpack_public_path__ + "static/img/chakanjietu2.8d1babd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/chakanjietu2.png
// module id = 3djq
// module chunks = 24